import { ThemeConfig, theme } from "antd";

export const GluceraTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    // Ensure light theme
    colorTextBase: "#1f2937",
    colorBgBase: "#ffffff",
    colorBgContainer: "#ffffff",
    colorBgLayout: "#ffffff",
    fontFamily: "var(--font-family)",
    fontSize: 16, // matches --font-size-base (1rem)
    borderRadius: 10,
  },
  components: {
    // Only styles that won't interfere with custom components
    Typography: {
      colorTextBase: "#66697c",
    },
    Tooltip: {
      colorBgSpotlight: "#66697C",
    },
  },
};
